// Example background shapes for the inventory map
export const exampleBackgroundShapes = [
  {
    id: 'background-image-logo',
    href: '/images/goldenSproutMilling.png',
    type: 'image',
    latitude: 43.45198,
    longitude: -80.50125,
    dimensions: {
      width: 30 / 2.25,
      height: 20 / 2.25,
      angle: 0,
    },
    style: { opacity: 1 },
  },
  {
    id: 'background-image-satelight',
    href: '/images/ControlTowerSatelightImage.png',
    type: 'image',
    latitude: 43.4518,
    longitude: -80.5014,
    dimensions: {
      width: 25,
      height: 25 * 0.559038662, // aspect ratio
      angle: 0,
    },
    style: { opacity: 1 },
  },

  {
    id: 'background-rectangle-1',
    type: 'rectangle',
    latitude: 43.45196,
    longitude: -80.5015725,
    dimensions: {
      width: 22.5,
      height: 15,
    },
    style: {
      fill: 'transparent',
      stroke: '#e0e0e0',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },

  {
    id: 'background-rectangle-1',
    type: 'rectangle',
    latitude: 43.451985,
    longitude: -80.501925,
    dimensions: {
      width: 20,
      height: 10,
    },
    style: {
      fill: 'transparent',
      stroke: '#e0e0e0',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },

  { id: 'not-installed-text-5', type: 'text', latitude: 43.45199525, longitude: -80.50204, dimensions: { text: 'ING 1', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-4', type: 'text', latitude: 43.45199525, longitude: -80.5019875, dimensions: { text: 'ING 2', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-3', type: 'text', latitude: 43.45199525, longitude: -80.501935, dimensions: { text: 'ING 3', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-2', type: 'text', latitude: 43.45199525, longitude: -80.5018825, dimensions: { text: 'ING 4', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-1', type: 'text', latitude: 43.45199525, longitude: -80.50183, dimensions: { text: 'ING 5', fontSize: 0.5 }, style: { fill: '#474747ff' } },

  { id: 'not-installed-text-6', type: 'text', latitude: 43.4519655, longitude: -80.50204, dimensions: { text: 'ING 6', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-7', type: 'text', latitude: 43.4519655, longitude: -80.5019875, dimensions: { text: 'ING 7', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-8', type: 'text', latitude: 43.4519655, longitude: -80.501935, dimensions: { text: 'ING 8', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-9', type: 'text', latitude: 43.4519655, longitude: -80.5018825, dimensions: { text: 'ING 9', fontSize: 0.5 }, style: { fill: '#474747ff' } },
  { id: 'not-installed-text-0', type: 'text', latitude: 43.4519655, longitude: -80.5018325, dimensions: { text: 'ING 10', fontSize: 0.5 }, style: { fill: '#474747ff' } },


  {
    id: 'not-installed-rectangle-1',
    type: 'rectangle',
    latitude: 43.4519975,
    longitude: -80.50182,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.4519975,
    longitude: -80.5018725,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.4519975,
    longitude: -80.501925,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.4519975,
    longitude: -80.5019775,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.4519975,
    longitude: -80.50203,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },


  {
    id: 'not-installed-rectangle-1',
    type: 'rectangle',
    latitude: 43.451967,
    longitude: -80.50182,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.451967,
    longitude: -80.5018725,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.451967,
    longitude: -80.501925,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.451967,
    longitude: -80.5019775,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },
  {
    id: 'not-installed-rectangle-2',
    type: 'rectangle',
    latitude: 43.451967,
    longitude: -80.50203,
    dimensions: {
      width: 3.05,
      height: 3.05,
    },
    style: {
      fill: '#F5F5F5',
      stroke: '#AEAEAF',
      strokeWidth: 1,
      opacity: 0.8,
    },
  },



{
    id: 'background-polygon-2',
    type: 'polygon',
    latitude: 40.7160,
    longitude: -74.0090,
    dimensions: {
      points: [
        { 'latitude': 43.45199, 'longitude': -80.501662 },
        { 'latitude': 43.451704, 'longitude': -80.501162 },
      ],
    },
    style: {
      fill: 'transparent',
      stroke: 'transparent',
      strokeWidth: 1,
      opacity: 0.6,
    },
  },

];
